import { FieldHasValue } from 'helpers/Validation';

export const AsFoundResultFormulaM68 = (formData) => {
    if (FieldHasValue(formData.F384AftConfirmThatExternalHeatAppliedField) && FieldHasValue(formData.F106AftHmireading1)) {
        if (formData.F384AftConfirmThatExternalHeatAppliedField === 'YES' && formData.F106AftHmireading1 === 'ALARM') {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
